import Component from './Component';
import { parseQuery } from './helpers/helpers';

class ViewComponent extends Component {
  constructor() {
    super();
    this.query = parseQuery(window.location.href);
  }
}

export default ViewComponent;